<img
  *ngIf="type === 'normal'"
  id="app-loading-spinner"
  data-testid="loading-spinner"
  src="/assets/images/player-spinner-new.svg"
  [style.width.px]="size"
  [style.height.px]="size"
/>
<img
  *ngIf="type === 'white'"
  id="app-loading-spinner"
  data-testid="loading-spinner"
  src="/assets/images/player-spinner-new-white.svg"
  [style.width.px]="size"
  [style.height.px]="size"
/>
<img
  *ngIf="type === 'dark'"
  id="app-loading-spinner"
  data-testid="loading-spinner"
  src="/assets/images/player-spinner-dark.svg"
  [style.width.px]="size"
  [style.height.px]="size"
/>
